import { useMemo } from "react";
import { useQuery } from "@grandvisionhq/graphql";
import { toAppointments } from "../../../mappers/Appointments/mappers/appointment.js";
import GET_MY_APPOINTMENTS from "../../../operations/queries/Appointments/operations/queries/get-my-appointments.js";
import useVirtualAppointment from "./useVirtualAppointment.js";
const useAppointments = () => {
  const { data, loading, error } = useQuery(GET_MY_APPOINTMENTS, {
    context: {
      timeout: 3e4
    }
  });
  const { isVirtualAppointmentType } = useVirtualAppointment();
  const allAppointmentsList = data?.me?.appointments;
  const filteredAppointmentsData = allAppointmentsList?.map((appointment) => {
    if (isVirtualAppointmentType(appointment.appointmentType)) {
      return {
        ...appointment,
        isVirtualAppointment: true
      };
    }
    return {
      ...appointment,
      isVirtualAppointment: false
    };
  });
  return useMemo(
    () => ({
      data: toAppointments(filteredAppointmentsData),
      loading,
      error
    }),
    [error, filteredAppointmentsData, loading]
  );
};
export {
  useAppointments
};
//# sourceMappingURL=useAppointments.js.map
